import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
      ]
    },
    lastName: {
      validations: [
      ]
    },
    email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    sitename: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:',
            mapping: 'firstName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address:',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Venue:',
            options:[
              {label: 'The Alligator Club' , value: 'The Alligator Club'},
              {label: 'Balmorhea Weddings and Events' , value: 'Balmorhea Weddings and Events'},
              {label: 'The Meekermark' , value: 'The Meekermark'},
              {label: 'Las Brisas Farms' , value: 'Las Brisas Farms'},
              {label: 'Magnolia Meadows' , value: 'Magnolia Meadows'},
              {label: 'Venue 311' , value: 'Venue 311'},
              {label: 'River Oaks Garden Club' , value: 'River Oaks Garden Club'},
              {label: 'Bank of America Tower' , value: 'Bank of America Tower'},
              {label: 'Private Residence' , value: 'Private Residence'},
              {label: 'THE SPRINGS - Alvarado' , value: 'THE SPRINGS - Alvarado'},
              {label: 'THE SPRINGS - Angleton - Magnolia Manor' , value: 'THE SPRINGS - Angleton - Magnolia Manor'},
              {label: 'THE SPRINGS - Angleton - Sycamore Hall' , value: 'THE SPRINGS - Angleton - Sycamore Hall'},
              {label: 'THE SPRINGS - Cypress' , value: 'THE SPRINGS - Cypress'},
              {label: 'THE SPRINGS - Denton-The Lodge' , value: 'THE SPRINGS - Denton-The Lodge'},
              {label: 'THE SPRINGS - Denton-The Ranch' , value: 'THE SPRINGS - Denton-The Ranch'},
              {label: 'THE SPRINGS - Katy - Stonecreek' , value: 'THE SPRINGS - Katy - Stonecreek'},
              {label: 'THE SPRINGS - Katy - Tuscany Hall' , value: 'THE SPRINGS - Katy - Tuscany Hall'},
              {label: 'THE SPRINGS - Lake Conroe - Pinehall' , value: 'THE SPRINGS - Lake Conroe - Pinehall'},
              {label: 'THE SPRINGS - Lake Conroe - Stonebrook' , value: 'THE SPRINGS - Lake Conroe - Stonebrook'},
              {label: 'THE SPRINGS - Magnolia - Pinehaven' , value: 'THE SPRINGS - Magnolia - Pinehaven'},
              {label: 'THE SPRINGS - Magnolia - Stonebridge' , value: 'THE SPRINGS - Magnolia - Stonebridge'},
              {label: 'THE SPRINGS - McKinney-Stone Hall' , value: 'THE SPRINGS-McKinney-Stone Hall'},
              {label: 'THE SPRINGS - Rockwall-The Manor' , value: 'THE SPRINGS-Rockwall-The Manor'},
              {label: 'THE SPRINGS - Rockwall-Poetry Hall' , value: 'THE SPRINGS-Rockwall-Poetry Hall'},
              {label: 'THE SPRINGS - Valleyview' , value: 'THE SPRINGS-Valleyview'},
              {label: 'THE SPRINGS - Wallisville' , value: 'THE SPRINGS - Wallisville'},
              {label: 'THE SPRINGS - Weatherford-Parker Manor' , value: 'THE SPRINGS-Weatherford-Parker Manor'},
              {label: 'THE SPRINGS - Weatherford- Westwood Hall' , value: 'THE SPRINGS-Weatherford- Westwood Hall'},
              {label: 'Other' , value: 'Other'},
            ],
            mapping: 'sitename'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Comments:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Corn & Rye Spirits Catering Contact Form',
    formId: '659',
    clientKey: '1B542E1A-4D84-4A7B-BDE6-B43E41527FFD',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
